import { render } from "./PageADAS.vue?vue&type=template&id=2742fc4a"
import script from "./PageADAS.vue?vue&type=script&lang=js"
export * from "./PageADAS.vue?vue&type=script&lang=js"

import "./PageADAS.vue?vue&type=style&index=0&id=2742fc4a&lang=scss"

import exportComponent from "D:\\PhpstormProjects\\alignment-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__